import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class MonedasService extends ApiService {
  entityType = EntityType.MONEDA;
  url = 'api/monedas/';
}
